import React from 'react';
import styled, { css } from 'styled-components';
import { ToastContainer } from 'react-toastify';
import { buttonize } from 'venn-utils';
import { GetColor } from '../../style/color';
import { ZIndex } from '../../zIndexValues';

const ToastCloseButton = ({ closeToast }: { closeToast: (e: React.MouseEvent<HTMLElement>) => void }) => {
  // Toastify types don't support keyboard events, but the event is unused so casting is safe
  const unsafeCastedCloseToast = closeToast as (e: React.MouseEvent<HTMLElement> | React.KeyboardEvent) => void;
  return <CloseButtonIcon className="fas fa-times" {...buttonize<HTMLElement>(unsafeCastedCloseToast)} />;
};

export const VennToastContainer = () => (
  <>
    <StyledToastContainer limit={5} closeButton={ToastCloseButton} containerId="default" />
    <StyledToastContainerWide limit={5} closeButton={ToastCloseButton} containerId="wide" />
  </>
);

export default VennToastContainer;

const toastTypeColors = css`
  .Toastify__toast.Toastify__toast--success {
    background-color: ${GetColor.Green};
  }

  .Toastify__toast.Toastify__toast--warning {
    /* dark orange */
    background-color: #e57f49;
  }

  .Toastify__toast.Toastify__toast--error {
    background-color: ${GetColor.Error};
  }

  .Toastify__progress-bar {
    background-color: ${GetColor.White};
    opacity: 1;
  }
`;

const baseToastStyles = css`
  &&&.Toastify__toast-container {
    z-index: ${ZIndex.InterComFront2};
  }

  .Toastify__toast-theme--light {
    --toastify-font-family: ${(props) => props.theme.Typography.fontFamily};
    --toastify-color-light: ${GetColor.HighlightDark};
    --toastify-text-color-light: ${GetColor.White};
    --toastify-toast-padding: 11px 16px;
    --toastify-toast-width: 388px;
    --toastify-toast-min-height: unset;
    --toastify-toast-bd-radius: 4px;
  }

  .Toastify__toast {
    font-size: 16px;
    column-gap: 16px;
  }

  .Toastify__toast-icon {
    width: 20px;
    margin: 0;

    i {
      font-size: 20px;
    }
  }

  ${toastTypeColors}
`;

const StyledToastContainer = styled(ToastContainer)`
  ${baseToastStyles}
`;

const StyledToastContainerWide = styled(ToastContainer)`
  ${baseToastStyles}

  .Toastify__toast-theme--light {
    --toastify-toast-width: 60vw;
  }
`;

const CloseButtonIcon = styled.i`
  color: ${GetColor.White};
  margin-left: auto;
  font-size: 20px;
`;
